import { v4 as uuidv4 } from 'uuid';
import { PineEconomicAnalysisToolRow } from './pine-economic-analysis-tool-row.model';
import { PineEconomicAnalysisToolAccuYieldRow } from './pine-economic-analysis-tool-accu-yield-row.model';

export class PineEconomicAnalysisReport {
  pineEconomicAnalysisReportId: string = uuidv4();
  propertyID?: string;
  paddockID?: string;
  siteQuality: number;
  species: string = 'RAD';
  wellSuited: number;
  suitable: number;
  moderatelySuitable: number;
  unsuitable: number;
  bioregion: string;
  thinAge: number;
  harvestAge: number;
  area: number;
  coordinates: number[];
  pineEconomicAnalysisRows: Array<PineEconomicAnalysisToolRow> = [];
  pineEconomicAnalysisAccuYieldRows: Array<PineEconomicAnalysisToolAccuYieldRow> =
    [];

  constructor(
    siteQuality: number,
    thinAge: number,
    harvestAge: number,
    area: number,
    wellSuited: number,
    suitable: number,
    moderatelySuitable: number,
    unsuitable: number,
    bioregion: string,
    coordinates: number[]
  ) {
    this.siteQuality = siteQuality;
    this.thinAge = thinAge;
    this.harvestAge = harvestAge;
    this.area = area;
    this.wellSuited = wellSuited;
    this.suitable = suitable;
    this.moderatelySuitable = moderatelySuitable;
    this.unsuitable = unsuitable;
    this.bioregion = bioregion;
    this.coordinates = coordinates;
  }
}
